<template>
    <asli-dropdown
        :id="buildId('type_of_item')"
        :name="buildId('type_of_item')"
        v-model="data.type"
        label="What type of item would you like to cover?"
        :options="lists?.specified_item_type"
        placeholder="Please select an option"
        rules="required-cover-item-type"
        large
    />
    <asli-text-input
        :id="buildId('item_description')"
        :name="buildId('item_description')"
        label="What is the description of the item?"
        rules="required:item_description"
        v-model="data.description"
        type="text"
        large
        max-length="80"
    />
    <asli-text-input
        :id="buildId('item_amount')"
        :name="buildId('item_amount')"
        :key="data.type"
        label="What is the value of the item?"
        :rules="itemAmountRules"
        v-model="data.value"
        type="text"
        :icon="euroIcon()"
        :mask="COMMA_NUMBER_MASK(10)"
    />
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { AsliDropdown, AsliTextInput } from "@mbs-npm/anpost-ui";
import { PropType, reactive, watch } from "vue";
import { Item } from "@/stores/risk/types/repeater/repeater-types";
import { useListStore } from "@/stores/lists/lists";
import { euroIcon, SpecifiedItemType } from "@/static/constants";
import { COMMA_NUMBER_MASK } from "@/static/masks";

const props = defineProps({
    item: {
        type: Object as PropType<Item>,
        required: true
    },
    index: {
        type: Number,
        required: true
    }
});

const emit = defineEmits<{ (e: "update", val: Item): void }>();

const listStore = useListStore();
const lists = computed(() => listStore?.lists);

const buildId = (id: string) => `${id}_${props.index}`;

const data = reactive<Item>({
    type: props.item.type,
    description: props.item.description,
    value: props.item.value
});

const itemAmountRules = computed(() => {
    const min = data.type === SpecifiedItemType.PedalCycle ? 150 : 100;
    const max = data.type === SpecifiedItemType.PedalCycle ? 9999 : 999999;
    return `required:item_amount|minAmount:${min},item_amount|maxAmount:${max},item_amount`;
});

watch(
    () => data,
    newData => {
        emit("update", newData);
    },
    { deep: true }
);
</script>
